const STATE = {

    update_project_visible: false,
    document_visible: false,
    add_documents_visible: false,
    add_docs_visible: false,
    compare_documents_visible: false,
    compare_documents_admin_visible: false,
    import_files_visible: false,
    references_visible: false,
    expired_visible: false,
    gallery_visible: false,
    menu_bar_visible: false,
    expired_doc_clip_visible: false,
    expired_reviews_visible: false,

}

const GETTERS = {

    update_project_visible: state => state.update_project_visible,
    document_visible: state => state.document_visible,
    add_documents_visible: state => state.add_documents_visible,
    add_docs_visible: state => state.add_docs_visible,
    compare_documents_visible: state => state.compare_documents_visible,
    compare_documents_admin_visible: state => state.compare_documents_admin_visible,
    import_files_visible: state => state.import_files_visible,
    references_visible: state => state.references_visible,
    expired_visible: state => state.expired_visible,
    gallery_visible: state => state.gallery_visible,
    menu_bar_visible: state => state.menu_bar_visible,
    expired_doc_clip_visible: state => state.expired_doc_clip_visible,
    expired_reviews_visible: state => state.expired_reviews_visible,

}

const MUTATIONS = {

    showUpdateProject(state) {
        state.update_project_visible = true
    },

    hideUpdateProject(state) {
        state.update_project_visible = false
    },

    showDocument(state) {
        state.document_visible = true
    },

    hideDocument(state) {
        state.document_visible = false
    },

    showAddDocuments(state) {
        state.add_documents_visible = true
    },

    hideAddDocuments(state) {
        state.add_documents_visible = false
    },

    showAddDocs(state) {
        state.add_docs_visible = true
    },

    hideAddDocs(state) {
        state.add_docs_visible = false
    },

    showCompareDocuments(state) {
        state.compare_documents_visible = true
    },

    hideCompareDocuments(state) {
        state.compare_documents_visible = false
    },

    showCompareDocumentsAdmin(state) {
        state.compare_documents_admin_visible = true
    },

    hideCompareDocumentsAdmin(state) {
        state.compare_documents_admin_visible = false
    },

    showImportFiles(state) {
        state.import_files_visible = true
    },

    hideImportFiles(state) {
        state.import_files_visible = false
    },

    showReferences(state) {
        state.references_visible = true
    },

    hideReferences(state) {
        state.references_visible = false
    },

    showExpired(state) {
        state.expired_visible = true
    },

    hideExpired(state) {
        state.expired_visible = false
    },

    showGallery(state) {
        state.gallery_visible = true
    },

    hideGallery(state) {
        state.gallery_visible = false
    },

    showMenuBar(state) {
        state.menu_bar_visible = true
    },

    hideMenuBar(state) {
        state.menu_bar_visible = false
    },

    showExpiredDocClip(state) {
        state.expired_doc_clip_visible = true
    },

    hideExpiredDocClip(state) {
        state.expired_doc_clip_visible = false
    },

    showExpiredReviews(state) {
        state.expired_reviews_visible = true
    },

    hideExpiredReviews(state) {
        state.expired_reviews_visible = false
    },

}

export default {
    namespaced: true,
    state: STATE,
    getters: GETTERS,
    mutations: MUTATIONS,
}


// WEBPACK FOOTER //
// ./src/vuex/modules/modal.js